import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdmin = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.0833 10.4917L10.6083 12.7667C10.6917 13.125 10.3 13.4084 9.98333 13.2167L8 12.0167L6.00833 13.2167C5.69167 13.4084 5.3 13.125 5.38333 12.7667L5.91667 10.5L4.16667 8.99171C3.88333 8.75004 4.03333 8.29171 4.4 8.25837L6.71667 8.05837L7.61667 5.92504C7.75833 5.58337 8.24167 5.58337 8.38333 5.92504L9.28333 8.05004L11.6 8.25004C11.9667 8.28337 12.1167 8.74171 11.8333 8.98337L10.0833 10.4917ZM1.49167 3.72504C0.891667 3.99171 0.5 4.59171 0.5 5.25004V9.16671C0.5 13.7917 3.7 18.1167 8 19.1667C12.3 18.1167 15.5 13.7917 15.5 9.16671V5.25004C15.5 4.59171 15.1083 3.99171 14.5083 3.72504L8.675 1.13337C8.24167 0.941707 7.75 0.941707 7.325 1.13337L1.49167 3.72504Z" })
});
export default SvgAdmin;
